/**
 * Contact inquiry type definitions
 */
import { Timestamp } from 'firebase/firestore';

export type InquiryStatus = 'new' | 'read' | 'replied' | 'archived';

export const InquiryStatusLabels: Record<InquiryStatus, string> = {
  new: 'New',
  read: 'Read',
  replied: 'Replied',
  archived: 'Archived',
};

export interface ContactInquiry {
  id: string;
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  status: InquiryStatus;
  isRead: boolean;
  createdAt: Timestamp;
}

export interface CreateInquiryData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}
